// S2-CC20.6b.2: React hook wrapping GET /v1/llm/reconciliation.
//
// Single fetch on mount. The backend applies a 5s server-side cache, and
// the endpoint is currently stubbed (status: 'not_configured') until CC5a
// ships. The UI treats that as the normal/expected state — no special
// error handling here; `snapshot.status === 'not_configured'` is valid
// data, not an error.
import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../utils/api';
import type { ReconciliationSnapshot } from '../types/llm';

export interface UseLLMReconciliationResult {
  snapshot: ReconciliationSnapshot | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useLLMReconciliation(): UseLLMReconciliationResult {
  const [snapshot, setSnapshot] = useState<ReconciliationSnapshot | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    setLoading(true);
    apiFetch<ReconciliationSnapshot>('/v1/llm/reconciliation')
      .then(data => {
        setSnapshot(data);
        setError(null);
      })
      .catch(err => {
        setError(err instanceof Error ? err.message : 'Failed to load reconciliation');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { snapshot, loading, error, refresh };
}
